import * as booking from './BookingAction';

export const bookingAction = booking;